import { render, staticRenderFns } from "./InventoryList.vue?vue&type=template&id=cf75ea20&scoped=true&"
import script from "./InventoryList.vue?vue&type=script&lang=js&"
export * from "./InventoryList.vue?vue&type=script&lang=js&"
import style0 from "./InventoryList.vue?vue&type=style&index=0&id=cf75ea20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf75ea20",
  null
  
)

export default component.exports